import formatMessage from './../i18n/formatMessage';

export default [
  formatMessage('acompanhamentoProdutor.nenhum'),
  formatMessage('acompanhamentoProdutor.emAlerta'),
  formatMessage('acompanhamentoProdutor.necessitaAplicacao')
];
